import React, { FC, ReactElement } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormEmergencyContactsModel } from '../../../../../shared/kiosk';
import { useTranslation } from '../../../../translations';
import { Fetcher, useFetcher } from '../../../../utils';
import {
  AbstractElementEditor,
  UpdateFormProps,
  UpdateFormPropsNoTrans,
} from './AbstractElementEditor';

export class EmergencyContactsEditor extends AbstractElementEditor<FormEmergencyContactsModel> {
  public getDescription(): string {
    return 'Emergency Contacts';
  }

  public getName(): string {
    return 'Emergency Contacts';
  }

  public getIcon(): string {
    return 'phone';
  }

  public override getUpdateForm({
    node,
    update,
  }: UpdateFormProps<FormEmergencyContactsModel>): ReactElement {
    return (
      <EmergencyContactsEditorForm
        node={node}
        update={(n) => {
          update(n);
        }}
      />
    );
  }
}

// eslint-disable-next-line @typescript-eslint/no-deprecated
const EmergencyContactsEditorForm: FC<UpdateFormPropsNoTrans<FormEmergencyContactsModel>> = ({
  node,
  update,
}) => {
  const { ts } = useTranslation();

  const options = useFetcher(async () => {
    return await api.getOptions('volunteer');
  }, []);

  if (!options.data) {
    return <Fetcher result={options} />;
  }

  return (
    <FormGroup check className="py-2">
      <Input
        checked={node.required ?? false}
        id="optionRequired"
        onChange={(e) => {
          update({ ...node, required: e.target.checked });
        }}
        type="checkbox"
      />
      <Label check for="optionRequired">
        {ts('required')}
      </Label>
    </FormGroup>
  );
};
